// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';
// IMPORT PROJECT REFERENCES
import {
    changePasswordChallenge,
    federatedLogin,
    login,
    logout,
} from '../state/actions/AuthActions';

import { Auth } from '@aws-amplify/auth';
import { Hub } from '@aws-amplify/core';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import Swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// COMPONENT
class LoginComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            submitted: false,
        };

        Hub.listen('auth', {
            onHubCapsule: ({ payload }) => {
                const { event } = payload;
                if (event === 'signIn') {
                    this.handleAuthStateChange('signedIn');
                }
            },
        });
    }

    handleChange = e => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleSubmit = e => {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password } = this.state;

        if (username && password) {
            this.props
                .login(username, password)
                .then(() => this.handleAuthStateChange('signedIn'))
                .catch(error => {
                    switch (error.code) {
                        case 'NEW_PASSWORD_REQUIRED': {
                            this.props.changePasswordChallenge(error);
                            break;
                        }
                        default: {
                            this.handleErrorMessage(error.message);
                            break;
                        }
                    }
                });
        }
    };

    handleAuthStateChange = state => {
        if (state === 'signedIn') {
            Auth.currentAuthenticatedUser()
                .then(user => {
                    this.props.federatedLogin(user);
                })
                .then(() => {
                    window.location.reload();
                });
        }
    };

    handleErrorMessage = (errorMessage, footer) => {
        Swal({
            title: 'Sign in failed',
            text: errorMessage,
            type: 'error',
            footer: footer,
        });
    };

    render() {
        const { loggingIn, user } = this.props;

        if (user && !loggingIn) {
            return <Redirect to="/" />;
        }

        return null;
    }
}

LoginComponent.propTypes = {
    logout: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    changePasswordChallenge: PropTypes.func.isRequired,
    federatedLogin: PropTypes.func.isRequired,
    loggingIn: PropTypes.bool.isRequired,
    user: PropTypes.object,

    newPasswordChallenge: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
    const { loggingIn, user, newPasswordChallenge } = state.auth;

    return { loggingIn, user, newPasswordChallenge };
}

const mapDispatchToProps = dispatch =>
    bindActionCreators({ logout, login, federatedLogin, changePasswordChallenge }, dispatch);

const hoc = connect(mapStateToProps, mapDispatchToProps)(LoginComponent);

export { hoc as LoginComponent };
